import { CanvasSettings } from '~/components/Toolbelt/components/CanvasSettings'
import { GenerateDimensionsButton } from '~/components/Toolbelt/components/GenerateDimensionsButton'
import { ToolbeltActions } from '~/components/Toolbelt/components/ToolbeltActions'
import { Separator } from '~/ui/Separator'
import { Toolbar } from '~/ui/Toolbar'

export const Toolbelt = () => {
  return (
    <Toolbar
      orientation="vertical"
      className="w-[95px] gap-1 absolute left-2 top-2 z-10 bg-zinc-800 px-1 py-2 rounded-md [&_svg]:w-[15px] [&_svg]:h-[15px] whitespace-nowrap"
    >
      <ToolbeltActions />
      <GenerateDimensionsButton />
      <Separator orientation="horizontal" className="my-1 border-none bg-zinc-400" />
      <CanvasSettings />
    </Toolbar>
  )
}
